// extracted by mini-css-extract-plugin
export default {"moduleListWrapper":"ModuleList_moduleListWrapper__bsjp9"};